import {useFindAllCategories} from "hooks/queries/category.query"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import {useEffect, useState} from "react"
import styled from "styled-components"
import {Category} from "dto/category/category"
import TtlDeviceStatusCounterPanel from "pages/dashboard/ttl-status/TtlDeviceStatusCounterPanel"
import {useQuery} from "react-query"
import {RealDeviceApi} from "api/real-device"
import {Counter, newCounter} from "store/dashboard/DashboardStore"
import {isEmergencyStatus, isErrorStatus, isNoneOperationStatus} from "dto/realdevice/devices"
import DeviceStatusSummaryCard from "pages/dashboard/ttl-status/DeviceStatusSummaryCard"
import TopLevelDeviceStatusView from "pages/dashboard/ttl-status/TopLevelDeviceStatusView"
import SecondLevelDeviceStatusView from "pages/dashboard/ttl-status/SecondLevelDeviceStatusView"

const useFindAllDevices = () => {
    return useQuery("real-device/list/status", async () => {
        const result = await RealDeviceApi.findAll()
        return result?.data?.body || []
    })
}
export const DeviceStatusViewByCategory = observer(() => {
    const {dashboardStore: {showTtlDeviceStatus, setShowTtlDeviceStatus}} = useRootStore()
    const [selectedCategory, setSelectedCategory] = useState<Category | undefined>()
    const devices = useFindAllDevices()?.data || []
    const allCategories = useFindAllCategories()?.data

    if (!showTtlDeviceStatus) return null
    return (
        <Container>
            <div style={{position: 'absolute', right: 20}}>
                <button className="delete is-large" aria-label="close"
                        onClick={() => setShowTtlDeviceStatus(false)}></button>
            </div>
            {selectedCategory ?
                <SecondLevelDeviceStatusView
                    allCategories={allCategories} devices={devices}
                    selectedCategory={selectedCategory}
                    onBackButtonClick={() => setSelectedCategory(undefined)}
                /> :
                <TopLevelDeviceStatusView
                    allCategories={allCategories} devices={devices}
                    onSelectCategory={(category: Category) => {
                        setSelectedCategory(category)
                    }}
                />
            }
        </Container>
    )
})


const Container = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  z-index: 1001;
  margin: 75px 10px 10px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.85);
  padding: 20px;
`
export default DeviceStatusViewByCategory